import {
    GET_SECTOR,
    GET_ALL_SECTORS,
    GET_SECTOR_REQUEST,
    CREATE_SECTOR,
    UPDATE_SECTOR,
    DELETE_SECTOR,
    CLEAR_SECTOR,
    SECTOR_ERROR,
    SECTOR_LOADING
} from '../actions/types';

const initialState = {
    sectors: [],
    sector: null,
    loading: false,
    error: null
};

export default function sectorReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SECTOR_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_SECTORS:
            return {
                ...state,
                sectors: payload,
                loading: false,
                error: null
            };

        case GET_SECTOR_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SECTOR:
            return {
                ...state,
                sector: payload,
                loading: false,
                error: null
            };

        case CREATE_SECTOR:
            return {
                ...state,
                sectors: [...state.sectors, payload],
                loading: false,
                error: null
            };

        case UPDATE_SECTOR:
            return {
                ...state,
                sectors: state.sectors.map(sector =>
                    sector._id === payload._id ? payload : sector
                ),
                sector: payload,
                loading: false,
                error: null
            };

        case DELETE_SECTOR:
            return {
                ...state,
                sectors: state.sectors.filter(sector => sector._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_SECTOR:
            return {
                ...state,
                sector: null,
                error: null
            };

        case SECTOR_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
